var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.2594 9.58824H13.8965V5.76471C13.8965 5.34412 13.5108 5 13.0394 5H9.61079C9.13936 5 8.75364 5.34412 8.75364 5.76471V9.58824H7.39079C6.62793 9.58824 6.24222 10.4141 6.78222 10.8959L10.7165 14.4059C11.0508 14.7041 11.5908 14.7041 11.9251 14.4059L15.8594 10.8959C16.3994 10.4141 16.0222 9.58824 15.2594 9.58824ZM5.32507 17.2353C5.32507 17.6559 5.71079 18 6.18222 18H16.4679C16.9394 18 17.3251 17.6559 17.3251 17.2353C17.3251 16.8147 16.9394 16.4706 16.4679 16.4706H6.18222C5.71079 16.4706 5.32507 16.8147 5.32507 17.2353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 96 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0073 1.72353H5.64282C3.63336 1.72353 2.00436 3.39544 2.00436 5.45784V17.5422C2.00436 19.6046 3.63336 21.2765 5.64282 21.2765H17.0073C19.0168 21.2765 20.6458 19.6046 20.6458 17.5422V5.45784C20.6458 3.39544 19.0168 1.72353 17.0073 1.72353ZM5.64282 0C2.70591 0 0.325073 2.44356 0.325073 5.45784V17.5422C0.325073 20.5564 2.70591 23 5.64282 23H17.0073C19.9442 23 22.3251 20.5564 22.3251 17.5422V5.45784C22.3251 2.44356 19.9442 0 17.0073 0H5.64282Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.d0959367b4fc89a058cc38c78ecee81a.svg";
export { ForwardRef as ReactComponent };